import Vue from "vue";
import VueRouter from "vue-router";
import VueCookies from "vue-cookies";
import { i18n } from "../plugins/i18n.js";
import store from "../store";
Vue.use(VueCookies);
Vue.$cookies.config("1d");
Vue.use(VueRouter);

// ! กัน bypass เข้าหน้าเวป
const ifAuthenticated = (to, from, next) => {
  if (Vue.$cookies.isKey("auth") === true) {
    // ! login success
    next();
  } else {
    // ! ไปเช็ค auth ก่อน
    // store.dispatch("login_authen",{}).then((res) => {
    //   if (res.status === "OK") {
    //     next();
    //   } else {
    //     next("/login");
    //   }
    // });
    next("/login");
  }
};
const routes = [
  {
    path: "/default",
    name: "home",
    component: () => import("../views/default_page.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login_page.vue"),
  },
  {
    path: "/loginAccesstoken",
    name: "loginAccesstoken",
    component: () => import("../views/page_loginAccesstoken.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/register_page.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () => import("../views/page_test.vue"),
  },
  {
    path: "/",
    redirect: "/dashboard",
    // name: "dashboard",
    // component: () => import("../views/dashboard_page.vue"),
    // beforeEnter: ifAuthenticated,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("../views/dashboard_page.vue"),
    beforeEnter: ifAuthenticated,
  },
  {
    path: "/invoice-billing",
    name: "invoice billing",
    component: () => import("../views/invoiceBilling_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Invoice Billing" },
  },
  {
    path: "/customer",
    name: "customer",
    component: () => import("../views/customer_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Customer" },
  },
  {
    path: "/customer-create",
    name: "customer-create",
    component: () => import("../views/customerCreate_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Create customer " },
  },
  {
    path: "/vendor-invoice",
    name: "invoice",
    component: () => import("../views/invoice_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Invoice" },
  },
  {
    path: "/vendor-invoice/invoice-create",
    name: "invoice-create",
    component: () => import("../views/invoiceCreate_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Create invoice" },
  },
  {
    path: "/inv/invoice-customer-import",
    name: "invoice-customer-import",
    component: () => import("../views/invoiceCustomerImport_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Import customer invoice" },
  },
  {
    path: "/receipt",
    name: "receipt",
    component: () => import("../views/receipt_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Receipt" },
  },
  {
    path: "/supplier",
    name: "supplier",
    component: () => import("../views/supplier_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Supplier " },
  },
  {
    path: "/create-supplier",
    name: "create-supplier",
    component: () => import("../views/createSupplier_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Supplier " },
  },
  {
    path: "/vendor-invoice/invoice-import",
    name: "invoice-import",
    component: () => import("../views/invoice_import_excel.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "invoice " },
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import("../views/setting_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "invoice " },
  },

  {
    path: "/setting-payment",
    name: "setting payment",
    component: () => import("../views/setting_payment.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "invoice " },
  },
  {
    path: "/setting-running-number",
    name: "setting running number",
    component: () => import("../views/setting_running_number.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "invoice " },
  },
  {
    path: "/setting-running-detail",
    name: "setting running detail",
    component: () => import("../views/setting_running_detail.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "invoice " },
  },
  {
    path: "/vendor-invoice/invoice-etax",
    name: "invoice-etax",
    component: () => import("../views/invoice_import_etax_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Invoice " },
  },
  {
    path: "/invoice-comfirm",
    name: "invoice-comfirm",
    component: () => import("../views/invoice_confirm_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Invoice " },
  },
  {
    path: "/customer-invoice-confirm",
    name: "customer-invoice-confirm",
    component: () => import("../views/customer_invoice_confirm_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "customer-invoice-confirm" },
  },
  {
    path: "/invoice-seller-comfirm",
    name: "invoice-seller-comfirm",
    component: () => import("../views/invoice_seller_confirm_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Invoice " },
  },
  {
    path: "/quotation",
    name: "quotation",
    component: () => import("../views/quotation_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Quotation" },
  },
  {
    path: "/quotation/quotation-create",
    name: "quotation_create",
    component: () => import("../views/quotationCreate_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Quotation" },
  },
  {
    path: "/quotation/quotation-import",
    name: "quotation_import",
    component: () => import("../views/quotationImport_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Quotation" },
  },
  {
    path: "/purchase-quotation",
    name: "purchase-quotation",
    component: () => import("../views/purchaseQuotation_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Purchase Quotation" },
  },
  {
    path: "/purchase-order",
    name: "purchase-order",
    component: () => import("../views/purchaseOrder_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Purchase Order" },
  },
  {
    path: "/purchase-order/purchase-order-create",
    name: "purchase-order-create",
    component: () => import("../views/poCreate_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Create purchase order" },
  },
  {
    path: "/purchase-order/purchase-order-upload-po",
    name: "purchase-order-upload-po",
    component: () => import("../views/customerUploadPO_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Purchase Order" },
  },
  {
    path: "/report-buyer",
    name: "report1",
    component: () => import("../views/reportBuyer_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Report Buyer" },
  },
  {
    path: "/report-seller",
    name: "report2",
    component: () => import("../views/reportSeller_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Report Seller" },
  },
  {
    path: "/create-edit-signature",
    name: "create-edit-signature",
    component: () => import("../views/page_crudSignature.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Create&Edit Signature" },
  },
  {
    path: "/create-signature",
    name: "create-signature",
    component: () => import("../views/createSignature_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Create Signature" },
  },
  {
    path: "/edit-signature",
    name: "edit-signature",
    component: () => import("../views/editSignature_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Edit Signature" },
  },
  {
    path: "/signatureData",
    name: "signatureData",
    component: () => import("../views/page_signature.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Data Signature" },
  },
  {
    path: "/vendor",
    name: "supplierOrder",
    component: () => import("../views/supplierPurchaseOrder_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Supplier Purchase Order" },
  },
  {
    path: "/inv",
    name: "customer-invoice",
    component: () => import("../views/customerInvoice_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Customer Invoice" },
  },
  {
    path: "/customer-billing",
    name: "customerBilling",
    component: () => import("../views/customerBilling_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Customer Invoice" },
  },

  {
    path: "/inv/invoice-customer-create",
    name: "invoiceCustomerCreate",
    component: () => import("../views/invoiceCustomerCreate.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Customer Invoice Create" },
  },
  {
    path: "/vendor-invoice-waiting-check",
    name: "invoiceWaitCheck",
    component: () => import("../views/waitingCheck_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Customer Invoice" },
  },
  {
    path: "/approve",
    name: "customerApprove",
    component: () => import("../views/waitingApprove_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Customer Invoice" },
  },
  {
    path: "/make-payment",
    name: "make-payment",
    component: () => import("../views/makePayments_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Payments" },
  },
  {
    path: "/make-payment/payments",
    name: "make-payment",
    component: () => import("../views/payments_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Payments" },
  },
  {
    path: "/receive-payment",
    name: "receive-payment",
    component: () => import("../views/receivePayments_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Receive Payments" },
  },
  {
    path: "/receive-payment/confirm",
    name: "receive-payment",
    component: () => import("../views/confirm_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Receive Payments Confirm" },
  },
  {
    path: "/etax",
    name: "etax",
    component: () => import("../views/etax_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "e-Tax Invoice & e-Receipt" },
  },
  {
    path: "/efactoring",
    name: "efactoring",
    component: () => import("../views/efactoring_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "e-Factoring" },
  },
  {
    path: "/cutBilling",
    name: "cutBilling",
    component: () => import("../views/setting_cutBilling.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "cutBilling" },
  },
  {
    path: "/productService",
    name: "productService",
    component: () => import("../views/productService_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "productService" },
  },
  {
    path: "/receive-product",
    name: "receiveProduct",
    component: () => import("../views/receiveProduct_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "receiveProduct" },
  },
  {
    path: "/receive-product/receive-create",
    name: "receiveProductCreate",
    component: () => import("../views/receiveProductCreate.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "receiveProductCreate" },
  },
  {
    path: "/billing",
    name: "billing",
    component: () => import("../views/billing_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "Billing" },
  },
  {
    path: "/receive-bills",
    name: "receive-bills",
    component: () => import("../views/receiveBills_page.vue"),
    beforeEnter: ifAuthenticated,
    meta: { title: "receiveBills" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  duplicateNavigationPolicy: "ignore",
});
router.beforeEach((to, from, next) => {
  // check lang
  if (localStorage.getItem("lang") === true && localStorage.getItem("lang") !== i18n.locale) {
    i18n.locale = localStorage.getItem("lang");
  } else if (!localStorage.getItem("lang")) {
    localStorage.setItem("lang", "th");
    i18n.locale = localStorage.getItem("lang");
  }

  next();
});
Vue.use(router);

export default router;
